<script setup>
import { 
	ref,
	onMounted,
} from 'vue'

const props = defineProps(['height', 'width'])
const emit = defineEmits(['onBegin', 'onEnd'])

const signaturePad = ref(null)

const onBegin = () => {
	signaturePad.value.resizeCanvas()
	emit('onBegin')
}

const onEnd = () => {
	emit('onEnd')
}

defineExpose({
	'pad': signaturePad,
})

onMounted(() => {
	if (props.modelValue) {
		signaturePad.value.lockSignaturePad()
	} else {
		signaturePad.value.openSignaturePad()
	}
})
</script>

<template>
<VueSignaturePad
	ref="signaturePad"
	:key="width"
	:width="width"
	:height="height"
	:options="{ onBegin, onEnd }"
	@touchstart.stop
	@touchmove.stop
	@touchend.stop
/>
</template>


<style lang="scss" scoped>

</style>